<template>
  <div class="online-courses-page">
    <div class="heading">
      <h1>
        Unlock the power of blockchain with our expert-led courses at Azadi Coin
        Academy!
      </h1>
    </div>
    <h3 v-if="!load || filteredCourses.length">FIND THE RIGHT COURSE FOR YOU</h3>
    <div class="filter-section" v-if="!load || filteredCourses.length">
      <label for="filter">Filter by</label>
      <select id="filter" v-model="filterOption">
        <option value="newly-launched">Newly Launched</option>
        <!-- Add more filter options if needed -->
      </select>
    </div>
    <div class="courses-grid" v-if="!load || filteredCourses.length">
      <div
        v-for="course in filteredCourses"
        :key="course.id"
        class="course-card"
        @click="handleRoute('/training-detail/'+course.id)"
      >
        <TrainingCard :course="course" />
      </div>
    </div>
    <div class="course-list-place" v-else>
      <h2>
        Currently, no live training courses are available. Stay tuned for upcoming sessions!
      </h2>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TrainingCard from "./TrainingCard.vue"
export default {
  components: {
    TrainingCard
  },
  data() {
    return {
      filterOption: "newly-launched",
      courses: [],
      load: false,
    };
  },
  computed: {
    filteredCourses() {
      // Logic to filter courses based on the selected option
      // (Here we return all courses for simplicity)
      return this.courses;
    },
  },
  mounted() {
    this.courseList();
  },
  methods: {
    handleRoute(route) {
      this.$router.push(route)
    },
    async courseList() {
      try {
        this.load = false;
        const response = await axios.get("training");
        this.courses = response.data.data;
        this.load = true;
      } catch (err) {
        this.load = true;
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.course-list-place {
  font-family: 'GothicB';
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 14rem;
  justify-content: center;
  margin-right: 1rem;
  color: #fff;
}
.online-courses-page {
  text-align: center;
  font-family: 'GothicB';
}
.heading {
  background-color: #0e1332;
}

h3 {
  max-width: 65rem;
  margin: 0 auto 2rem;
  text-align: left;
  padding: 0 1.5rem;
  color: #fff;
}
.online-courses-page h1 {
  padding: 3rem 1.5rem;
  max-width: 65rem;
  margin: 0 auto 2rem;
  color: #fff;
  text-align: left;
  line-height: 4rem;
}

.filter-section {
  text-align: left;
  margin: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 65rem;
  margin: 0 auto 2rem;
  padding: 0 1.5rem;
}

.filter-section label {
  margin-right: 1rem;
  font-weight: 700;
  color: #fff;
}

.filter-section select {
  padding: 0.5rem;
  background-color: transparent;
  border: 1px solid #f0c57a;
  color: #f0c57a;
  font-family: 'Gothic';
  border-radius: 5px;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  /* grid-template-columns: repeat(auto-fit, 320px); */
  gap: 1.5rem;
  max-width: 60rem;
  margin: 0 auto 5rem;
  justify-content: start;
  padding: 0 1.5rem;
}

.course-card {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: #fff;
  background-color: #121E4A;
  text-align: left;
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 781px){
  .courses-grid .course-card {
    max-width: 18rem;
  }
}


.course-card:hover {
  transform: scale(1.1);
  transition: all .5s;
  cursor: pointer;
}

@media screen and (max-width: 850px) {
  .course-card {
    max-width: initial;
  }
}
</style>
